const trimTrailingSlash = (value) => value?.replace(/\/+$/, "");

const apiUrl = trimTrailingSlash(process.env.REACT_APP_API_URL);
if (process.env.NODE_ENV === "production" && (!apiUrl || apiUrl.startsWith("<"))) {
  throw new Error("REACT_APP_API_URL is required for a production build");
}

export const config = Object.freeze({
  apiUrl: apiUrl || "http://localhost:8000",
  rootDomain: process.env.REACT_APP_ROOT_DOMAIN || "localhost",
  razorpayKeyId: process.env.REACT_APP_RAZORPAY_KEY_ID || "",
  sentryDsn: process.env.REACT_APP_SENTRY_DSN || "",
  requestTimeoutMs: 75000,
});
